import { useQueryClient } from 'react-query'
import { useStrategy } from '../hooks/useStrategy'
import { getActivitiesQueryKey } from './useGetActivitiesQuery'
import { getOrgActivitiesQueryKey } from './useGetOrgActivitiesQuery'

export const useInvalidateActivitiesQuery = () => {
    const queryClient = useQueryClient()
    const strategy = useStrategy()

    const invalidateActivitiesQuery = async () => {
        await Promise.all([
            queryClient.invalidateQueries(getActivitiesQueryKey(strategy?._id)),
            queryClient.invalidateQueries(getOrgActivitiesQueryKey(strategy?.organizationId)),
        ])
    }

    return { invalidateActivitiesQuery }
}
